exports.install = function(Vue) {
  Vue.prototype.$isMobile = function() {
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return mobile != null;
  };
};



// WEBPACK FOOTER //
// ./src/utils/isMobile.js